// Centralized query keys for React Query
export const analysisKeys = {
  // Planner related queries
  planner: {
    analysis: (experimentName: string) =>
      ['planner', 'analysis', experimentName] as const,
    metricDimensions: (metricName: string) =>
      ['planner', 'metricDimensions', metricName] as const,
  },
} as const;
